<template>
  <v-card flat width="100%">
    <v-card-title>Groups</v-card-title>
    <v-card-text>
      <v-col cols="12">
        <select-groups :clear="clear" v-model="group"></select-groups>
        <v-chip
          @click:close="deleteGroup(group)"
          class="mr-1"
          close
          v-for="group in data"
          :key="group"
          >{{ group }}</v-chip
        >
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectGroups from './SelectGroups'
export default {
  props: { value: { default: [] } },
  components: {
    SelectGroups
  },
  data() {
    return {
      group: '',
      data: [],
      clear: true
    }
  },
  watch: {
    group(value) {
      if (value) {
        if (!this.data.includes(value)) {
          this.data.push(value)
        }
        this.group = ''
        this.clear = !this.clear
      }
    },
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
      // this.items.push(value)
    }
  },
  methods: {
    deleteGroup(group) {
      this.data = this.data.filter(i => i !== group)
    }
  }
}
</script>

<style></style>
